import React, { useState } from 'react'
import { BarChartOutlined, DownloadOutlined } from '@ant-design/icons'
import { GraviButton, Texto, onExport } from '@gravitate-js/excalibrr'
import { Dropdown, Menu, Select, Switch, Tooltip } from 'antd'
import moment from 'moment'
import { hierarchyItems } from '../constants'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { DownloadButton } from '@components/_SiteWide/Grid/ActionButtons/DownloadButton'
const { Option } = Select

export const PageControls = ({
  viewMetricBy,
  setViewMetricBy,
  gridAPIRef,
  setShowingChart,
  periodDates,
  selectedPeriodDates,
  setSelectedPeriodDates,
  clearData,
  setLoadingDatesInput,
  loadingDatesInput,
}) => {
  return (
    <div className='flex items-center'>
      <GraviButton buttonText='Deselect Rows' onClick={() => gridAPIRef.current?.deselectAll()} />
      <PeriodSelect
        periodDates={periodDates}
        selectedPeriodDates={selectedPeriodDates}
        setSelectedPeriodDates={setSelectedPeriodDates}
        clearData={clearData}
        setLoadingDatesInput={setLoadingDatesInput}
        loadingDatesInput={loadingDatesInput}
      />
      <HierarchySelect viewMetricBy={viewMetricBy} setViewMetricBy={setViewMetricBy} />
      <DownloadButton
        fileName={`${viewMetricBy}-Metrics-Export_${moment().format('YYYY-MM-DD')}`}
        gridAPIRef={gridAPIRef}
      />
      <ChartDisplayToggle setShowingChart={setShowingChart} />
    </div>
  )
}

const PeriodSelect = ({
  periodDates,
  selectedPeriodDates,
  setSelectedPeriodDates,
  clearData,
  setLoadingDatesInput,
  loadingDatesInput,
}) => {
  periodDates.sort((a, b) => new Date(b) - new Date(a))
  const onChange = (value) => {
    if (value?.length < 1) setLoadingDatesInput(true)
    setSelectedPeriodDates(value)
    clearData()
  }

  return (
    <>
      <Texto
        category='label'
        appearance='medium'
        weight='bold'
        align='right'
        style={{ minWidth: 100 }}
        className='mr-4'
      >
        PERIOD DATES
      </Texto>
      <Select
        disabled={loadingDatesInput}
        maxTagCount='responsive'
        value={selectedPeriodDates}
        onChange={onChange}
        mode='multiple'
        style={{ minWidth: 200 }}
      >
        {periodDates.map((option, i) => (
          <Option key={i} value={option}>
            {formatters.DATE(moment(option))}
          </Option>
        ))}
      </Select>
    </>
  )
}
const ChartDisplayToggle = ({ setShowingChart }) => (
  <div className='mx-3'>
    <Tooltip title='Show Comparison/History Chart'>
      <Switch
        checkedChildren={<BarChartOutlined />}
        onChange={setShowingChart}
        unCheckedChildren={<BarChartOutlined />}
      />
    </Tooltip>
  </div>
)

const HierarchySelect = ({ viewMetricBy, setViewMetricBy }) => (
  <div className='flex items-center pr-3 border-right'>
    <Texto category='label' appearance='medium' weight='bold' align='right' style={{ minWidth: 100 }} className='mr-4'>
      VIEW METRICS BY
    </Texto>
    <GraviButton
      theme2={viewMetricBy === hierarchyItems.DRIVERS}
      onClick={() => setViewMetricBy(hierarchyItems.DRIVERS)}
      buttonText='Drivers'
      className='mr-2'
      style={{ height: 27, lineHeight: '1.0em' }}
    />
    <GraviButton
      theme2={viewMetricBy === hierarchyItems.DEPOTS}
      onClick={() => setViewMetricBy(hierarchyItems.DEPOTS)}
      buttonText='Depots'
      className='mr-2'
      style={{ height: 27, lineHeight: '1.0em' }}
    />
    <GraviButton
      theme2={viewMetricBy === hierarchyItems.SUPERVISORS}
      onClick={() => setViewMetricBy(hierarchyItems.SUPERVISORS)}
      buttonText='Supervisors'
      className='mr-2'
      style={{ height: 27, lineHeight: '1.0em' }}
    />
    <GraviButton
      theme2={viewMetricBy === hierarchyItems.MARKETS}
      onClick={() => setViewMetricBy(hierarchyItems.MARKETS)}
      buttonText='Markets'
      className='mr-2'
      style={{ height: 27, lineHeight: '1.0em' }}
    />
  </div>
)
